<template>
  <div class="drill-center">
    <div class="drill-top">
      <img src="@/assets/img/drillCenter/logo.png"  @click="back" alt="">

      <span class="top-left">可视应急指挥中心 {{ emergencyPlanId?'(局端)':'(校端)' }}</span>
      <span class="top-right">
        <the-now-time></the-now-time>
      </span>
    </div>
    <div class="drill-content">
      <el-row class="center-content">
        
        <el-col  class="center-content-left" style="flex:1">
          <el-row class="left-top">
            <el-col :span="24" class="left-top-content">
              <div class="left-list">
                <div class="left-list-li"     :class="{ active: showSelect == 0 }">
                  <span
                
                    @click="showMonitor"
                  >
                    应急监控
                  </span>
                </div>
                <div class="left-list-li" style="margin-top: 20px;"  :class="{ active: showSelect == 1 }">
                  <span @click="showLive">
                    应急直播
                  </span>
                </div>
              </div>
              <drill-center-monitor
                v-if="showSelect == 0"
                class="content-right"
                :playVideoList="playVideoList"
              >
              </drill-center-monitor>

              <drill-center-live
                v-if="showSelect == 1"
                class="content-right"
                :schoolId="schoolId"
                :drillPlanId= "drillPlanList[thisSelectPlan].emergencyPlanId "
                ref="live"
              >
              </drill-center-live>
            </el-col>
          </el-row>
          <div class="left-bottom">
            <!-- 演练器材 -->
            <drill-center-equipment
              :safeDrillPlanDevice="safeDrillPlanDevice"
            ></drill-center-equipment>
            <!-- 应急队伍 -->
            <drill-center-team
              :userInfo="userInfoList"
            ></drill-center-team>
            <!-- 疏散路线图 -->
            <drill-center-route :routeImg="routeImg"></drill-center-route>
          </div>
        </el-col>
        <el-col style="width: 400px;padding:2rem 2rem 0 0;" >
          <el-row class="righttop" > 
            <el-col :span="24" class="center-content-right">
              <select
                v-if="startStatus == 0"
                v-model="thisSelectPlan"
               
                @change="select"
              >

                <!-- <option value="">请选择您要演练的预案</option> -->
                <option
                  v-for="(value, index) in drillPlanList"
                  :key="index"
                  :value="index"
                >
                  {{ value.emergencyPlanName }}
                </option>
              </select>
             
              <!-- <select v-if="startStatus == 1" disabled v-model="thisSelectPlan">
                <option
                  v-for="(value, index) in drillCenterDetial.drillPlans"
                  :key="index"
                  :value="value.id"
                >
                  {{ value.title }}
                </option>
              </select> -->
            </el-col>
            <div class="startd" v-if="drillPlanDetail.emergencyPlanState==0" > 未启动</div>
            <div class="startd" style="color: red;" v-if="drillPlanDetail.emergencyPlanState==1" > 已启动</div>
         
          </el-row>
          
          <!-- 应急广播 -->
          <drill-center-audio
            :startStatus="startStatus"
            :audioList="audioList"
            @getRadioRecord="getRadioRecord"
          ></drill-center-audio>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import DrillCenterMonitor from "./cloudComponents/DrillCenterMonitor.vue";
import DrillCenterLive from "./cloudComponents/DrillCenterLive.vue";
import TheNowTime from "./cloudComponents/theNowTime.vue";
import drillCenterEquipment from "./cloudComponents/drillCenterEquipment.vue";
import drillCenterTeam from "./cloudComponents/drillCenterTeam.vue";
import drillCenterRoute from "./cloudComponents/drillCenterRoute.vue";
import drillCenterStopwatch from "./cloudComponents/drillCenterStopwatch.vue";
import drillCenterAudio from "./cloudComponents/drillCenterAudio.vue";
export default {
  name: "DrillCenter",
  components: {
    DrillCenterMonitor,
    DrillCenterLive,
    TheNowTime,
    drillCenterEquipment,
    drillCenterTeam,
    drillCenterRoute,
    drillCenterStopwatch,
    drillCenterAudio
  },
  props: {},
  data() {
    return {
      userInfo: "",
      schoolId: parseInt(this.$store.state.schoolId),
      audioImg: "audio-stop.png",
      routeImg: [], // 疏散路线图
      drillPlanDetail: {},
      thisSelectPlan: 0, // 选中的预案
      audioList: [], // 广播列表
      playVideoList: [], // 视频列表
      startStatus: 0, // 应急演练是否启动
      recordId: "", // 演练记录Id
      drillType: "",
      showSelect: 0, // 0 显示监控，1 显示直播
      isComeLive: 0, // 0 不来自应急直播，1 来自应急直播
      userInfoList:[],
      safeDrillPlanDevice:[],
      drillPlanList:[],
      type:'',
      emergencyPlanId:""
    };
  },
  watch: {},
  computed: {},
  methods: {
    back(){
    window.history.back()
    },  
    // 获取应急演练中心详情
    async getDrillCenterDetails(id) {
      let req = {
          schoolId: this.schoolId,
          pageNum:1,
          pageSize:50
        };
      // let res = await this.$Http.getDrillCenterDetails(req);
      let res = await this.$Http.resourcePlan(req);
      if (res.code == 200) {
        this.drillPlanList = res.data.list
        this.refresh()
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
   async getEduCenterDetails(data){
      let req = {
        emergencyPlanId:data,
          pageNum:1,
          pageSize:1
        };
      // let res = await this.$Http.getDrillCenterDetails(req);
      let res = await this.$Http.eduResourcePlanMain(req);
      if (res.code == 200) {
    
        this.drillPlanList = res.data.list
        this.refresh()
       
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      this.refresh()
    },
    // 选择预案
    select(val) {
      // console.log(val)
      // this.getDrillCenterDetails(val);
      this.showSelect=0
      this.refresh()
     
    },
    refresh(){
      let emergencyMonitorVideoJson;
      let emergencyEvacuateMapJson;
        this.drillPlanDetail =this.drillPlanList[this.thisSelectPlan];
        if(this.drillPlanDetail.emergencyEvacuateMapJson){
           emergencyEvacuateMapJson = JSON.parse( this.drillPlanDetail.emergencyEvacuateMapJson)
        }
        if(this.drillPlanDetail.emergencyMonitorVideoJson){
           emergencyMonitorVideoJson = JSON.parse( this.drillPlanDetail.emergencyMonitorVideoJson)
        }
        if(this.drillPlanDetail.emergencyRanksJson){
          this.userInfoList =  JSON.parse( this.drillPlanDetail.emergencyRanksJson)
        }
        if(this.drillPlanDetail.emergencyEquipmentJson){
          this.safeDrillPlanDevice =  JSON.parse( this.drillPlanDetail.emergencyEquipmentJson)
        }
        let routeImg = [];
        this.schoolId= this.drillPlanDetail.emergencySchoolId

        if(emergencyEvacuateMapJson.length > 0) {

          emergencyEvacuateMapJson.forEach((element) => {
            if (element) {
              
              routeImg.push(
                this.$store.state.config.fileUrl + element.evacuateMapUrl
              );
            }
          });
        }
        this.routeImg = routeImg;
        if (emergencyMonitorVideoJson.length > 0) {
          let playVideoList = [];
          emergencyMonitorVideoJson.forEach((element, index) => {

            if (element) {

              // let playData = this.getPlayUrl(element,index)
              playVideoList.push({
                id: index,
                videoAddress: element.monitorName,
                code:element.deviceId
              });
            }
          
          });
          setTimeout(() => {
            this.playVideoList = playVideoList;

          }, 800);
        } else {
          this.playVideoList = [];
        }
  
       
          this.getAudioList(this.drillPlanDetail.emergencySchoolId)
        
        // if(this.$refs.live){
        //   this.$refs.live.reFreshlive()
        // }
      //   setTimeout(() => {
      //   this.showMonitor();
      // }, 500);
        // this.showLive()
      //   setTimeout(() => {
      //   this.showMonitor();
      // }, 500);
    },
 async   getPlayUrl(element,i){
     let data = {
            code:element.deviceId,
            streamType: 1,
            forceH264: true,
          }
       let req  = await this.$playHttp.getPlayUrl(data)
       let playVideo= {
            playStatus: true,
            id: "video-" + i,
            // m3u8_sd: videoList[i].hls,
            m3u8_hd: 'wss://vs.zzsasoft.com' + req.data.data.flv,
            // flv_sd: videoList[i].flv,
            // flv_hd: videoList[i].flvHd,
            videoAddress: req.data.data.name,
            addressName:element.monitorName,
          

          }
       
        return  playVideo
   
    },
    startTip() {
      this.$confirm(
        "启动预案将有可能触动广播警报，确定启动该预案吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.start();
        })
        .catch(() => {});
    },
    // 开启预案
    start() {
      if (this.thisSelectPlan == "") {
        this.$message("没有可以启动的预案！");
        return;
      }
      if (
        this.userInfo.userId == this.drillPlanDetail.directId ||
        this.userInfo.userId == this.drillPlanDetail.viceDirectId
      ) {
        this.startStatus = 1;
        this.addDrill(this.thisSelectPlan, this.userInfo.userId);
      } else {
        this.$message("您不是指挥员，没有权限操作预案！");
      }
    },
    // 停止预案
    stop() {
      this.startStatus = 0;
      this.drillPlanDetail.status = 0;
      // 清空定时器
      this.$refs.stopwatch.clearStartWatch();
      this.editDrillRecord();
      setTimeout(() => {
        this.showMonitor();
      }, 500);
    },
    // 增加播放广播演练记录
    getRadioRecord(voiceName = "") {
      this.drillType = 1;
      this.addDrillOperation(voiceName);
    },
    // 演练启动时添加演练
    async addDrill(id, userId) {
      let req = {
        drillPlanId: id,
        opener: userId
      };
      // console.log(req)
      let res = await this.$Http.addDrill(req, true);
      if (res.code == 200) {
        // console.log(res);
        this.recordId = res.data;
        this.drillType = 0;
        this.editDrillStatus(1);
        // 开启定时器
        this.$refs.stopwatch.startStopwatch();
      } else if (res.code == 101) {
      } else {
        this.startStatus = 0;
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 添加演练记录具体操作
    async addDrillOperation(info) {
      let operate;
      let userName = this.userInfo.userName;
      switch (this.drillType) {
        case 0:
          operate = userName + " 开启演练";
          break;
        case 1:
          operate = userName + " 播放一次应急广播 " + "“" + info + "”";
          break;
        case 2:
          operate = userName + " 进行了一次应急喊话";
          break;
        case 3:
          operate = userName + " 发布了一个演练直播";
          break;
        case 4:
          operate = userName + " 演练结束";
          break;
        default:
          break;
      }
      // console.log(operate)
      // return;
      let req = {
        type: this.drillType,
        recordId: this.recordId,
        operate: operate
      };
      let res = await this.$Http.addDrillOperation(req, true);
      if (res.code == 200) {
        // console.log(res);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 演练结束时编辑演练记录信息
    async editDrillRecord() {
      let req = {
        drillPlanId: this.thisSelectPlan
      };
      let res = await this.$Http.editDrillRecord(req, true);
      if (res.code == 200) {
        // console.log(res);
        this.drillType = 4;
        this.editDrillStatus(0);
        this.addDrillOperation();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 编辑应急预案状态
    async editDrillStatus(status) {
      let req = {
        status: status,
        id: this.thisSelectPlan
      };
      let res = await this.$Http.editDrillStatus(req);
      if (res.code == 200) {
        // console.log(res);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 查看监控
    showMonitor() {
      if (this.showSelect == 0) {
        return;
      }
      this.showSelect = 0;
      this.refresh(this.thisSelectPlan);
    },
    // 查看直播
    showLive() {
     
      if (this.drillPlanDetail.emergencyPlanState == 0) {
        this.showMonitor()
        this.$message("预案未启动，应急直播不能查看，请先开启预案！");
        return;
      }
      if (this.drillPlanDetail.emergencyPlanState == 1) {
        this.showSelect = 1;
        this.isComeLive = 1;

        setTimeout(() => {
          this.$refs.live.getLiveList();
        }, 300);
      } else {
        this.$message("预案未启动，应急直播不能查看，请先开启预案！");
      }
    },
   async getAudioList(schoolid){
    
     
      let res = await this.$Http.schoolResourcesList(  {
        pageNum: 1,
        pageSize: 20,
        resourceSchoolId:schoolid?schoolid: this.$store.getters.getUserInfo.schoolId
      });
      if (res.code == 200) {
        this.audioList = res.data.list || [];

      } else if (res.code == 101) {
       
      } else {
      
        this.$message({
          type: "error",
          message: "查询失败"
        });
      }
    },
  },
  created() {
   
      if(this.$route.query.data){

      this.emergencyPlanId = this.$route.query.data
      this.getEduCenterDetails(this.emergencyPlanId);
      }else{
        this.getDrillCenterDetails();
        this.getAudioList()
      }
   
  
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  },
  mounted() {},
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.drill-center {
  height: 100%;
  width: 100%;
  min-width: 1300px;
    background-image: url('~@/assets/img/drillCenter/bg.png');
}
.drill-top {
  // background-color: #111111;
  background-image: url('~@/assets/img/drillCenter/header.png');
  background-size: 100% 100%;
  line-height: 66px;
  height: 66px;
  width: 100%;
  // padding: 1rem 2rem;
  text-align: center;
  color: #fff;
  font-weight: 500;
  font-size: 36px;
  position: relative;

  .top-right {
    color: #fff;
    font-size: 2rem;
    position: absolute;
    left: 0;
    font-weight: 600;
  }
  img{
    position: absolute;
    width: 140px;
    height: auto;
    left: 30px;
    top: 16px;
    bottom: 0;
    margin: auto;
  }
}
.drill-content {
  height: 90%;
  width: 100%;
  // background-color: #333333;
  float: left;
}
.center-content {
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  
}
.center-content-left {
  padding: 2rem;
  height: 100%;
  .left-top {
    height: 70%;
  
    .left-top-content {
      height: 100%;
      padding: 0;
      margin: 0;

    }
    .left-list {
      width: 5%;
      color: #21bf25;
      height: 100%;
      float: left;
    }
    .left-list-li {
      text-align: center;
      height: 48%;
      font-size: 22px;
      background: #05204C;
      // background: linear-gradient(180deg, rgba(81, 193, 255, 0.2627) 0%, rgba(69, 189, 255, 0) 29%, rgba(45, 181, 255, 0) 72%, rgba(36, 178, 255, 0.26) 100%);
      cursor: pointer;
      color:rgba($color: #fff, $alpha: .7);
      span {
        display: inline-block;
        letter-spacing: 2rem;
        height: 100%;
        /*文字竖排显示*/
        writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
        writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
        // background-color: #333333;
        cursor: pointer;
        &.active {

          // background-color: #191919;
        }
      }
    }
    .active{
      background: linear-gradient( 180deg, #05204C 0%, #14428D 54%, #05204C 99%);
      color: #52FFFB;
    }
    .content-right {
      float: right;
      height: 99%;
      width:93%;
      background-image: url('~@/assets/img/drillCenter/centerbg2.png');
    background-size: 100% 100%;
    padding: 2rem;
    margin-bottom: 2rem;
    }
  }
  .left-bottom {
    height: 30%;
    display: flex;
    justify-content: space-between;
  }
}
.center-content-right {
  // padding:0  2rem 0 0;
  text-align: center;
  margin-bottom: 35px;
  select {
    width: 100%;
    text-align: center;
    padding: 1rem;
    width: 350px;

    //background-color: #191919;
    margin: 20px auto ;
    color: rgba(69,189,255,1) ;
    font-size: 18px;
height: 50px;
background: linear-gradient( 180deg, rgba(81,193,255,0.2627) 0%, rgba(69,189,255,0) 29%, rgba(45,181,255,0) 72%, rgba(36,178,255,0.26) 100%);
border-radius: 2px 2px 2px 2px;
border: 1px solid rgba(37,176,255,0.5);
  }
  .start-action {
    // width: 100%;
    width: 350px;
    display: block;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
background: linear-gradient( 180deg, rgba(81,193,255,0.2627) 0%, rgba(69,189,255,0) 29%, rgba(45,181,255,0) 72%, rgba(36,178,255,0.26) 100%);
border-radius: 2px 2px 2px 2px;
border: 1px solid rgba(37,176,255,0.5);
      color: #fff;
      font-size: 20px;
    
    &.stop-action {
      color: red;
    }
  }
}
.righttop{
  // background-image: url('');
  background-image: url('~@/assets/img/drillCenter/righttop.png');
  background-size: 100% 100%;
  height: 260px;
  padding-top: 20px;
}
</style>
<style>
  .assembly_box{
    border: none!important;
    background-image: url('~@/assets/img/drillCenter/lefttop.png');
  background-size: 100% 100%;
  width: 470px!important;
  position: relative;
  padding-top: 3rem!important;
  }
  .assembly_title{
    font-weight: 500;
    font-size: 16px!important;;
    color: #FFFFFF;
    /* margin: 10px 0 0 10px; */
    position: absolute;
    left:20px;
    top:10px;
    display: flex;
    flex-direction: column;
  }
  .assembly_list{
    color: rgba(255, 255, 255, .9)!important;
    padding: 1rem 2rem!important;
  }
  .startd{
    font-size: 35px;
    font-weight: 800;
    text-align: center;color: #fff;
  }
</style>
